module.exports = __webpack_public_path__ + "img/ebtang.781896a4.svg";